import { lazy } from 'react';

// project imports

import MinimalLayout from 'layout/MinimalLayout';

import Loadable from 'ui-component/Loadable';
import RouterErrorElement from './RouterErrorElement';
import AuthGuard from 'utils/route-guard/AuthGuard';

// login routing
const PaySuccess = Loadable(lazy(() => import('views/pay')));

// ==============================|| AUTH ROUTING ||============================== //

const PayRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MinimalLayout />
        </AuthGuard>
    ),
    errorElement: <RouterErrorElement />,
    children: [
        {
            path: '/paysuccess',
            element: <PaySuccess />
        }
    ]
};

export default PayRoutes;
